export default "__VITE_ASSET__3SPXevWz__"